<template>
  <!-- 注意：此页面为老系统直接复制过来：保持原有功能 -->
  <div class="teacher-manage">
    <p class="tit">教师管理</p>
    <div class="menu-wrapper">
      <div class="left-group">
        <span class="room-count">教师（{{ totalCount }}）</span>
        <a-select
          default-value="状态：全部"
          option-label-prop="label"
          @change="changeTchStatus"
          :dropdownStyle="{ textAlign: 'center' }"
        >
          <a-select-option value="0" label="状态：全部"> 全部 </a-select-option>
          <a-select-option value="2" label="状态：已激活">
            已激活
          </a-select-option>
          <a-select-option value="1" label="状态：未激活">
            未激活
          </a-select-option>
        </a-select>
      </div>
      <div class="right-group">
        <a-input
          v-model="searchValue"
          placeholder="搜索教师名称"
          @pressEnter="serachEvent"
        >
          <a-icon slot="prefix" type="search" />
        </a-input>
        <span @click="importModel = true" class="print-btn ZHIHUISHU_QZMD">导入</span>
        <span @click="addTchModel = true" class="add-btn ZHIHUISHU_QZMD">添加教师</span>
      </div>
    </div>
    <div v-if="isNoData" class="no-data">
      <img
        src="//image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202110/bf88d3ddad394dbeb2766f8fd9687975.png"
        width="270"
        height="255"
      />
      <span class="no-data-tit">暂无教师管理</span>
    </div>
    <div class="table-data" v-else>
      <a-table
        @change="tableChangeEvent"
        :columns="columns"
        :data-source="teacherData"
        :pagination="{ pageSize: 20, total: totalCount }"
        :row-key="(record, index) => index"
        :loading="loading"
      >
        <a slot="num" slot-scope="text, record, index">{{
          index + 1 + (page - 1) * 20
        }}</a>
        <span slot="action" slot-scope="text, record">
          <span @click="openDeleteModel(record)" class="delete ZHIHUISHU_QZMD">删除</span>
        </span>
        <span slot="activeStatus" slot-scope="text">
          {{ text === 1 ? '未激活' : '已激活' }}
        </span>
      </a-table>
    </div>
    <a-modal
      wrapClassName="customModal  importClass"
      centered
      :maskClosable="false"
      :closable="false"
      v-model="importModel"
      @ok="handleBindDevice"
    >
      <template slot="title">
        <p class="tit">批量导入</p>
        <div class="header-group">
          <img
            class="ZHIHUISHU_QZMD"
            @click="importModel = false"
            src="../../assets/img/close@2x.png"
            width="26"
            height="26"
          />
        </div>
      </template>
      <div class="model-content">
        <p class="tit">
          学校<span style="color: #e02020; margin-left: 10px">*</span>
        </p>
        <a-select
          :defaultValue="selectSchool"
          @change="handleSchoolChange"
          style="margin-bottom: 30px; width: 100%"
          showSearch
          optionFilterProp="children"
        >
          <a-select-option
            v-for="(item, index) in schoolList"
            :key="item.id"
            :value="item.schoolId"
          >
            {{ item.schoolName }}
          </a-select-option>
        </a-select>
        <a-upload-dragger
          :file-list="fileList"
          :before-upload="beforeUpload"
          accept=".xls,.xlsx"
          name="file"
          method="post"
          action="//simple-class.zhihuishu.com/simple-class/admin/teacherManage/uploadTeacherDatas"
          :headers="{ Authorization: token }"
          @change="uploadChange"
          :remove="removeChange"
        >
          <img src="../../assets/img/excl-icon@2x.png" width="30" height="32" />
          <p class="tit1">上传表格</p>
          <p class="tit2">也可直接拖拽到此处上传（支持格式：xls，xlsx）</p>
        </a-upload-dragger>
      </div>
      <div class="download-content ZHIHUISHU_QZMD" @click="downloadStencil">
        <a-icon type="download" />
        下载教师模版
      </div>
      <template slot="footer">
        <span @click="importModel = false" class="btn ZHIHUISHU_QZMD">取消</span>
        <span @click="importTeacherInfos" class="btn confirm ZHIHUISHU_QZMD">确定</span>
      </template>
    </a-modal>
    <a-modal
      wrapClassName="customModal addTchClass"
      centered
      :maskClosable="false"
      :closable="false"
      v-model="addTchModel"
      @ok="handleBindDevice"
    >
      <template slot="title">
        <p class="tit">添加教师</p>
        <div class="header-group">
          <img
            class="ZHIHUISHU_QZMD"
            @click="addTchModel = false;selectSchool = schoolList[0].schoolId"
            src="../../assets/img/close@2x.png"
            width="26"
            height="26"
          />
        </div>
      </template>
      <div class="device-info">
        <p class="tit">
          学校<span style="color: #e02020; margin-left: 10px">*</span>
        </p>
        <a-select
          :value="selectSchool"
          @change="handleSchoolChange"
          style="margin-bottom: 30px; width: 100%"
          showSearch
          optionFilterProp="children"
        >
          <a-select-option
            v-for="(item, index) in schoolList"
            :key="item.id"
            :value="item.schoolId"
          >
            {{ item.schoolName }}
          </a-select-option>
        </a-select>
        <p class="tit">
          教师姓名<span style="color: #e02020; margin-left: 10px">*</span>
        </p>
        <a-input
          v-model="addTchParams.teacherName"
          placeholder="请填写教师姓名"
        />
        <p class="tit">
          教工号<span style="color: #e02020; margin-left: 10px">*</span>
        </p>
        <a-input v-model="addTchParams.code" placeholder="请填写教工号" />
        <p class="tit">所属学院</p>
        <a-input
          v-model="addTchParams.collegeName"
          placeholder="请填写所属学院"
        />
      </div>
      <template slot="footer">
        <span @click="addTchModel = false;selectSchool = schoolList[0].schoolId" class="btn ZHIHUISHU_QZMD">取消</span>
        <span @click="saveTeacherInfo" class="btn confirm ZHIHUISHU_QZMD">确定</span>
      </template>
    </a-modal>
    <a-modal
      wrapClassName="customModal bindDeviceClass closeLiveClass"
      centered
      :maskClosable="false"
      :closable="false"
      v-model="deleteTchModel"
      @ok="handleBindDevice"
    >
      <div class="close-live">
        <img
          class="close-icon ZHIHUISHU_QZMD"
          @click="deleteTchModel = false"
          src="../../assets/img/close@2x.png"
          width="26"
          height="26"
        />
        <img src="../../assets/img/bulb@2x.png" width="90" height="90" />
        <p class="text">确定删除此教师吗？</p>
      </div>
      <template slot="footer">
        <span @click="deleteTchModel = false" class="btn confirm ZHIHUISHU_QZMD">再想想</span>
        <span @click="deleteTeacher" class="btn ZHIHUISHU_QZMD">删除</span>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
const columns = [
  {
    title: '序号',
    dataIndex: 'num',
    key: 'num',
    scopedSlots: { customRender: 'num' },
    width: 150,
    align: 'center',
  },
  {
    title: '学校',
    dataIndex: 'schoolName',
    key: 'schoolName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '教师姓名',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' },
    width: 280,
    align: 'center',
  },
  {
    title: '教工号',
    dataIndex: 'code',
    key: 'code',
    ellipsis: true,
    width: 120,
    align: 'center',
  },
  {
    title: '学院',
    dataIndex: 'collegeName',
    key: 'collegeName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '状态',
    dataIndex: 'activeStatus',
    key: 'activeStatus',
    scopedSlots: { customRender: 'activeStatus' },
    ellipsis: true,
    align: 'center',
  },
  // {
  //   title: '手机号',
  //   dataIndex: 'mobile',
  //   key: 'mobile',
  //   scopedSlots: { customRender: 'mobile' },
  //   ellipsis: true,
  //   class: 'tel'
  // },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    ellipsis: true,
    class: 'action',
    align: 'center',
  },
]
export default {
  name: 'TeacherManagement',
  data() {
    return {
      teacherData: [{}],
      columns,
      importModel: false,
      addTchModel: false,
      deleteTchModel: false,
      checkedList: [],
      fileList: [],
      page: 1,
      activeStatus: 0,
      searchValue: '',
      currentTchData: {},
      addTchParams: {
        teacherName: '',
        code: '',
        collegeName: '',
      },
      isNoData: false,
      loading: false,
      totalCount: 0,
      filePath: null,
      schoolList: [],
      selectSchool: '',
    }
  },
  computed: {
    ...mapGetters('userInfo', ['token']),
  },
  created() {
    this.findTeacherInfos()
    this.getSelectSchoolList()
  },
  methods: {
    handleSchoolChange(val) {
      this.selectSchool = val
    },
    async getSelectSchoolList() {
      try {
        let res = await this.$http.getSelectSchoolList()
        if (res.code === 200 && res.rt) {
          this.schoolList = res.rt
          this.selectSchool = this.schoolList[0]?.schoolId || ''
        }
      } catch (err) {
        console.log(err)
      }
    },
    serachEvent() {
      this.page = 1
      this.findTeacherInfos()
    },
    changeTchStatus(v) {
      this.activeStatus = v
      this.page = 1
      this.findTeacherInfos()
    },
    openDetailModel(record) {
      console.log('recourd--', record)
      this.currentTchData = JSON.parse(JSON.stringify(record))
      this.deviceDetailModel = true
    },
    openDeleteModel(record) {
      console.log('recourd--', record)
      this.currentTchData = JSON.parse(JSON.stringify(record))
      this.deleteTchModel = true
    },
    async saveTeacherInfo() {
      if (!this.addTchParams.teacherName || !this.addTchParams.code)
        return this.$message.warning('请填写教师姓名和教工号')
      let req = {
        ...this.addTchParams,
        ...{
          schoolId: this.selectSchool,
        },
      }
      let result = await this.$http.saveTeacherInfo(req)
      console.log(result)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('添加教师成功')
      this.addTchModel = false
      this.selectSchool = this.schoolList[0].schoolId || ''
      this.findTeacherInfos()
      this.addTchParams = {
        teacherName: '',
        code: '',
        collegeName: '',
      }
    },
    deleteTeacher() {
      let _params = {
        id: this.currentTchData.id,
      }
      this.$api.deleteTeacherInfo(_params).then((res) => {
        if (res.code === 200) {
          this.deleteTchModel = false
          this.findTeacherInfos()
        }
      })
    },
    findTeacherInfos() {
      this.loading = true
      let _params = {
        activeStatus: this.activeStatus,
        teacherName: this.searchValue,
        pageNum: this.page,
        pageSize: 20,
      }
      this.$api.findTeacherInfos(_params).then((res) => {
        console.log('findTeacherInfos--', res)
        if (res.code === 200) {
          this.loading = false
          this.teacherData = res.rt.list
          this.totalCount = res.rt.totalCount
          if (!this.searchValue) {
            this.isNoData = res.rt.list.length === 0
          }
        }
      })
    },
    tableChangeEvent(pagination) {
      this.page = pagination.current
      this.findTeacherInfos()
    },
    handleBindDevice() {},
    onChange(checkedValues) {
      this.checkedList.push(checkedValues)
      console.log('checked = ', checkedValues)
      console.log('value = ', this.checkedList)
    },
    uploadChange(value) {
      let res = value.file.response
      if (res) {
        if (res.code === 200) {
          this.filePath = res.rt
        }
      }
    },
    removeChange() {
      this.filePath = null
      this.fileList = []
    },
    importTeacherInfos() {
      if (this.filePath) {
        this.$api
          .importTeacherInfos({ filePath: this.filePath, schoolId: this.selectSchool })
          .then((res) => {
            if (res.code === 200) {
              this.importModel = false
              this.filePath = null
              this.fileList = []
              this.$message.success(res.msg)
              this.findTeacherInfos()
            } else {
              this.$message.warning(res.msg)
            }
          })
      } else {
        this.$message.warning('请先上传表格文件')
      }
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file]
      this.fileList = this.fileList.slice(-1)
    },
    downloadStencil() {
      window.open(
        'https://file.zhihuishu.com/zhs_yufa_150820/aidedteaching/COURSE_FOLDER/202107/07cc1a5a535745a0ae534e170c6f795e.xls'
      )
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .ant-select-selection--single {
  height: 40px;
}
::v-deep .ant-select-selection__rendered {
  line-height: 36px;
}
.teacher-manage {
  min-height: 996px;
  text-align: left;
  background: #fff;
  padding-top: 19px;
  box-shadow: 0 0 10px #ddd;
  border-radius: 10px;
  .no-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    min-height: 600px;
    .no-data-tit {
      margin-top: 20px;
      font-size: 14px;
      color: #231815;
    }
  }
  .tit {
    height: 25px;
    line-height: 25px;
    margin: 0 0 10px 26px;
    padding-left: 10px;
    border-left: 4px solid #3db166;
    box-sizing: content-box;
    font-size: 18px;
  }
  .menu-wrapper {
    display: flex;
    margin: 0 40px 20px;
    justify-content: space-between;
    .left-group {
      display: flex;
      align-items: center;
      .room-count {
        margin-right: 10px;
      }
      .ant-select {
        margin-right: 20px;
        width: 174px;
      }
    }
    .right-group {
      display: flex;
      align-items: center;
      .print-btn,
      .add-btn {
        flex-shrink: 0;
        width: 114px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border-radius: 4px;
        border: 1px solid #ededed;
        font-size: 16px;
        cursor: pointer;
      }
      .print-btn {
        margin: 0 20px;
      }
      .add-btn {
        background: #3db166;
        border: 1px solid #3db166;
        color: #fff;
      }
    }
  }
  .table-data {
    padding: 0 40px;
    .qrcode-icon {
      cursor: pointer;
    }
    .delete {
      cursor: pointer;
    }
   ::v-deep{
      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td {
        border-bottom: 0;
      }
      .ant-table-thead > tr > th {
        background: #f6f6f6;
      }
      .ant-table-tbody {
        tr:nth-child(even) {
          background: #f4f7fa;
        }
      }
      .action {
        text-align: center;
        .action-icon {
          cursor: pointer;
        }
      }
      .ant-table-pagination {
        float: none;
        text-align: center;
      }
    }
  }
  .qrcode-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    overflow: auto;
    background: rgba(0, 0, 0, 0.5);
  }
}
::v-deep {
  .ant-select-dropdown {
    text-align: center;
  }
  .importClass {
    .ant-modal {
      width: 660px !important;
      height: 540px;
      padding-bottom: 0;
      .ant-modal-content {
        height: 540px;
        .ant-modal-header {
          border-bottom: 0;
          padding: 40px 40px 17px;
          .ant-modal-title {
            display: flex;
            align-items: center;
            .tit {
              flex: 1;
              font-size: 22px;
            }
            .header-group {
              .ant-input-affix-wrapper {
                width: 212px;
              }
              img {
                cursor: pointer;
                margin-left: 20px;
              }
            }
          }
        }
        .ant-modal-body {
          padding: 0 40px;
          .model-content {
            height: 250px;
            background: #f6f6f6;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
            border-radius: 8px;
            border: 1px solid #ededed;
            .tit {
              margin: 10px 0 5px 10px;
            }
            .tit1 {
              margin: 12px 0 10px;
              font-size: 18px;
              color: #2b2f3b;
            }
            .tit2 {
              font-size: 12px;
              color: #a6a6a6;
            }
          }
          .download-content {
            cursor: pointer;
            margin: 130px 0 0px;
            color: #3db166;
          }
        }
        .ant-modal-footer {
          display: flex;
          justify-content: center;
          border-top: 0;
          padding: 0;
          .btn {
            text-align: center;
            width: 88px;
            height: 32px;
            line-height: 32px;
            border-radius: 16px;
            border: 1px solid #d4d4d4;
            cursor: pointer;
            &.confirm {
              margin-left: 24px;
              background: #3db166;
              border: 1px solid #3db166;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .addTchClass {
    .ant-modal {
      width: 660px !important;
      height: 596px;
      padding-bottom: 0;
      .ant-modal-content {
        height: 596px;
        .ant-modal-header {
          border-bottom: 0;
          padding: 40px 40px 17px;
          .ant-modal-title {
            display: flex;
            align-items: center;
            .tit {
              flex: 1;
              font-size: 22px;
            }
            .header-group {
              .ant-input-affix-wrapper {
                width: 212px;
              }
              img {
                cursor: pointer;
                margin-left: 20px;
              }
            }
          }
        }
        .ant-modal-body {
          padding: 0 40px;
          .model-content {
            height: 250px;
            background: #f6f6f6;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
            border-radius: 8px;
            border: 1px solid #ededed;
            .tit1 {
              margin: 12px 0 10px;
              font-size: 18px;
              color: #2b2f3b;
            }
            .tit2 {
              font-size: 12px;
              color: #a6a6a6;
            }
          }
          .download-content {
            margin: 30px 0 0px;
            color: #3db166;
          }
        }
        .ant-modal-footer {
          display: flex;
          justify-content: center;
          border-top: 0;
          padding: 0;
          .btn {
            text-align: center;
            width: 88px;
            height: 32px;
            line-height: 32px;
            border-radius: 16px;
            border: 1px solid #d4d4d4;
            cursor: pointer;
            &.confirm {
              margin-left: 24px;
              background: #3db166;
              border: 1px solid #3db166;
              color: #fff;
            }
          }
        }
        .device-info {
          height: 435px;
          margin-bottom: 20px;
          padding: 20px;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
          border-radius: 8px;
          .tit {
            margin-bottom: 10px;
            font-size: 18px;
            color: #2b2f3b;
          }
          .input-flex {
            display: flex;
            justify-content: space-between;
            .ant-input {
              width: 260px;
            }
          }
          .ant-select {
            // wid;
          }
          .ant-input {
            margin-bottom: 30px;
            width: 100%;
            height: 40px;
            border-radius: 4px;
            border: 1px solid #d4d4d4;
          }
        }
      }
    }
  }
  .bindDeviceClass {
    .ant-modal {
      width: 800px !important;
      height: 650px;
      padding-bottom: 0;
      .ant-modal-content {
        height: 650px;
        .ant-modal-header {
          border-bottom: 0;
          padding: 40px 40px 17px;
          .ant-modal-title {
            display: flex;
            align-items: center;
            .tit {
              flex: 1;
              font-size: 22px;
            }
            .header-group {
              .ant-input-affix-wrapper {
                width: 212px;
              }
              img {
                cursor: pointer;
                margin-left: 20px;
              }
            }
          }
        }
        .ant-modal-body {
          padding: 0 40px;
          .device-bind {
            margin-bottom: 20px;
            padding: 24px 20px 20px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
            border-radius: 8px;
            height: 169px;
            .tit {
              margin-bottom: 23px;
              font-size: 18px;
              color: #2b2f3b;
            }
            .device-group {
              display: flex;
              flex-wrap: wrap;
              overflow-y: scroll;
              height: 90px;
              .item {
                display: flex;
                align-items: center;
                height: 34px;
                margin: 0 20px 10px 0;
                padding: 0 10px 0 20px;
                border-radius: 20px;
                border: 1px solid #d4d4d4;
                img {
                  cursor: pointer;
                }
              }
            }
          }
          .device-list {
            margin-bottom: 20px;
            padding: 20px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
            border-radius: 8px;
            height: 300px;
            overflow-y: scroll;
            .tit {
              display: flex;
              margin: 0 20px 20px 30px;
              font-size: 14px;
            }
            .device-item {
              display: flex;
              margin-bottom: 30px;
              .ant-checkbox-wrapper,
              .ant-checkbox,
              .ant-checkbox-input,
              .ant-checkbox-inner {
                width: 20px;
                height: 20px;
              }
              .device-info {
                // user-select: none;
                margin-left: 10px;
                width: 100%;
                display: flex;
                .num {
                  width: 257px;
                }
                .name {
                  width: 297px;
                }
              }
            }
          }
        }
        .ant-modal-footer {
          display: flex;
          justify-content: center;
          border-top: 0;
          padding: 0;
          .btn {
            text-align: center;
            width: 88px;
            height: 32px;
            line-height: 32px;
            border-radius: 16px;
            border: 1px solid #d4d4d4;
            cursor: pointer;
            &.confirm {
              margin-left: 24px;
              background: #3db166;
              border: 1px solid #3db166;
              color: #fff;
            }
          }
        }
        .ant-modal-close {
        }
      }
    }
  }
  .closeLiveClass {
    .ant-modal {
      width: 360px !important;
      height: 272px;
      padding-bottom: 0;
      .ant-modal-content {
        position: relative;
        height: 272px;
        .ant-modal-body {
          padding: 0 32px;
        }
        .close-live {
          margin-bottom: 40px;
          padding-top: 46px;
          text-align: center;
          .text {
            font-size: 16px;
            margin-top: 20px;
            color: #354052;
          }
          .close-icon {
            position: absolute;
            top: 12px;
            right: 12px;
            cursor: pointer;
          }
        }
      }
      .ant-modal-footer {
        .confirm {
          margin: 0 24px 0 0 !important;
        }
      }
    }
  }
}
</style>
